module.exports = __webpack_public_path__ + "static/media/fashion-6.6a8285a5.jpg";